import React from 'react';
import styled from 'styled-components';
import { Accordion, AccordionItem, AccordionHeader, AccordionDetail, AccordionTitle } from '@vds/accordions';
import PropTypes from 'prop-types';
// import { ModalBody } from '@vds/modals';
import DarkView from '../common/DarkView';
import { dataTrack } from '../../utils/vzdl';
import Button from '../common/Button';
import { updateHelpView } from './actions';
import { getCurrentDocument, setModalScroll } from '../../utils/helperUtil';
import { pageJson } from './constants';
import { closeModalWindow } from '../common/modal/action';

const StickyCta = styled.div`
  @media (min-width: 768px) {
    background-color: white;
    bottom: 0;
    padding: 6px 0px 0px 0px;
  }
`;

const DarkViewHeaderReskin = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;

const Reskin = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
  padding-top: 10px;
`;

const StyledParagraphReskin = styled.p`
  padding-top: 0.6rem;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
`;

const HelpViewList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const HelpViewListItem = styled.li`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-align: left;
`;

class Help extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getDocument = getCurrentDocument();
  }

  componentDidMount() {
    setModalScroll(500);
  }

  enteringYourAddress = (e) => {
    e.preventDefault();
  };

  onBackClick = () => {
    updateHelpView(this.props.dispatch, false);
    if (this.props.loopQualApp.lq4) {
      closeModalWindow(this.props.dispatch);
    }
    const ele = this.getDocument.querySelector('#support-drawer');
    ele?.focus();
  };

  enteringYourUnit = (e) => {
    e.preventDefault();
  };

  render() {
    const dartViewContent = (
      <>
        <StyledParagraphReskin>{pageJson.hereToHelp}</StyledParagraphReskin>
        <Reskin>
          {pageJson.callUs}
          {/* <br />
          {pageJson.lteSupportNo}
          <br />
          {pageJson.fiosSupportNo} */}
        </Reskin>
        <HelpViewList>
          <HelpViewListItem>{pageJson.lteSupportNo}</HelpViewListItem>
          <HelpViewListItem>{pageJson.fiosSupportNo}</HelpViewListItem>
        </HelpViewList>
      </>
    );
    const isHomeLQ = this.props.loopQualApp?.homeLQ;
    return (
      <>
        {/* <ModalBody> */}
        <Accordion id="accordionHelpSection">
          <AccordionItem data-track={dataTrack('link', pageJson.helpEnterAddress)}>
            <AccordionHeader onClick={this.enteringYourAddress}>
              <AccordionTitle>{pageJson.enterAddress}</AccordionTitle>
            </AccordionHeader>
            <AccordionDetail>
              <p className="margin-bottom-tiny">{pageJson.CheckSpelling}</p>
              <p className="margin-bottom-tiny">{pageJson.useCompleteAddress}</p>
              <p className="margin-bottom-tiny">{pageJson.abbreviationBefore}</p>
              <p className="margin-bottom-tiny">{pageJson.abbreviationAfter}</p>
              <p className="margin-bottom-zero">{pageJson.actualStreetAddress}</p>
            </AccordionDetail>
          </AccordionItem>
          <AccordionItem data-track={dataTrack('link', pageJson.needHelpEnterUnitNumber)}>
            <AccordionHeader onClick={this.enteringYourUnit}>
              <AccordionTitle>{pageJson.enterUnitNumber}</AccordionTitle>
            </AccordionHeader>
            <AccordionDetail>
              <p className="margin-bottom-tiny">{pageJson.liveInApartment}</p>
              <p className="margin-bottom-tiny">{pageJson.liveInbuilding}</p>
              <p className="margin-bottom-zero">{pageJson.useSpaces}</p>
            </AccordionDetail>
          </AccordionItem>
        </Accordion>
        <div style={{ marginTop: '28px' }}>
          <DarkView
            header={<DarkViewHeaderReskin>{pageJson.reachExpert}</DarkViewHeaderReskin>}
            body={dartViewContent}
            loopQualApp={this.props.loopQualApp}
            width="90%"
          />
        </div>
        {/* </ModalBody> */}
        {!isHomeLQ && (
          <StickyCta>
            {/* <footer> */}
            <Button onClick={() => this.onBackClick()} data-track={dataTrack('link', pageJson.helpBackCTA)}>
              {pageJson.backCTA}
            </Button>
            {/* </footer> */}
          </StickyCta>
        )}
      </>
    );
  }
}
Help.propTypes = {
  loopQualApp: PropTypes.string,
  dispatch: PropTypes.string,
};
export default Help;
